import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {InicioFaces} from '../interfaces/inicioFaces';
import {HttpParams} from  "@angular/common/http";
import {environment} from "../../environments/environment";
import Constants from "../lib/Constants";



@Injectable({
providedIn: 'root'
})
export class CreadorService {
public httpOptions = {
headers: new HttpHeaders({
'Access-Control-Allow-Origin': '*'
})

};

/*API_ENDPOINT: string ='http://'+window.location.hostname+':3001/api';*/
API_ENDPOINT: string = Constants.BASEURLAPI + '/api';


constructor(private httpClient: HttpClient) { }




static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {

let config = {
'required': 'Este campo es requerido'
};

return config[validatorName];
}


public mostrarAreas2() {
return this.httpClient.get(this.API_ENDPOINT + '/mostrarAreas2', this.httpOptions);
}


public mostrarAlbumes() {
    return this.httpClient.get(this.API_ENDPOINT + '/mostrarAlbumes', this.httpOptions);
}

public listarEnlace() {
return this.httpClient.get(this.API_ENDPOINT + '/listarEnlace', this.httpOptions);
}
public mostrarAprobacion() {
return this.httpClient.get(this.API_ENDPOINT + '/mostrarAprobacion', this.httpOptions);
}

public almacenarPropietarios(crear : any) {
const  params = new  HttpParams().set('areaid', crear.areaid).set('extension', crear.extension).set('nombreE', crear.nombreE);
return this.httpClient.get(this.API_ENDPOINT + '/almacenarPropietarios',{params});
} 


public almacenarEnlace(enlace : any) {
const  params = new  HttpParams().set('opcion', enlace.opcion).set('url', enlace.url).set('name', enlace.name);
return this.httpClient.get(this.API_ENDPOINT + '/almacenarEnlace',{params});
} 
public crearArea(area : any) {
    console.log('epaaaaaaaaa --')
    const  params = new  HttpParams().set('carea', area.carea);
    return this.httpClient.get(this.API_ENDPOINT + '/crearArea',{params});
    } 

public buscarArea(verArea: any) {
    console.log("que jodas",verArea);
    const  params = new  HttpParams().set('idArea', verArea.idArea);
    return this.httpClient.get(this.API_ENDPOINT + '/buscarArea', this.httpOptions);
    }

aprobado(id : any) {
const  params = new  HttpParams().set('id', id);
return this.httpClient.get(this.API_ENDPOINT + '/aprobado',{params});
} 

eliminarArea(id : any) {
    console.log('porque no service');
    const  params = new  HttpParams().set('id', id);
    return this.httpClient.get(this.API_ENDPOINT + '/eliminarArea',{params});
    } 

desAprobado(id : any) {
const  params = new  HttpParams().set('id', id);
return this.httpClient.get(this.API_ENDPOINT + '/desAprobado',{params});
} 


buscarExtension(busca : any){
const  params = new  HttpParams().set('busarea', busca.busarea);
return this.httpClient.get(this.API_ENDPOINT + '/buscarExtension',{params});

}


buscarEnlace(ver : any){
const  params = new  HttpParams().set('busOpc', ver.busOpc);
return this.httpClient.get(this.API_ENDPOINT + '/buscarEnlace',{params});

}


eliminarPropietarios(id: any){
const  params = new  HttpParams().set('id', id)
return this.httpClient.get(this.API_ENDPOINT + '/eliminarPropietarios',{params});

}

eliminarEnlaces(idunion: any){
const  params = new  HttpParams().set('idunion', idunion)
return this.httpClient.get(this.API_ENDPOINT + '/eliminarEnlaces',{params});

}

almacenPublicidad(formData : FormData, crearP : any){
    return this.httpClient.post<any>(this.API_ENDPOINT+'/almacenPublicidad/',formData,{reportProgress : true,
                 observe : 'events'});
   }

   
registraAlbum(formData : FormData, crearA : any){
console.log("omggggg di que si entras/*/**/*/*/*/*/*/ ");
    return this.httpClient.post<any>(this.API_ENDPOINT+'/registraAlbum/',formData,{reportProgress : true,
            observe : 'events'});
    }   

guardarFotos(formData : FormData, asigna : any){
    console.log("****** ", formData);
        return this.httpClient.post<any>(this.API_ENDPOINT+'/guardarFotos/',formData,{reportProgress : true,
                     observe : 'events'});
       }

uploadFile(formData) {
 
    let urlApi = this.API_ENDPOINT + '/subir';
    return this.httpClient.post<any>(urlApi, {params :formData});
 }

}
